import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Header } from './header.js';
import { Footer } from './footer.js';

let activationFaq=[];

export default class VerifyEmail extends Component {

  constructor(props) {
    super(props);
    this.state = {
      successfullyVerified: null
    };
  }

  componentDidMount() {
    const token = this.props.match.params.token;
    const url = `/api/verify-email?token=${token}`;
    fetch(url)
      .then(resp => resp.json())
      .then(data => {
        this.setState({
          successfullyVerified: data.success
        });
      })
      .catch(() =>
        this.setState({
          successfullyVerified: false
        })
      );
  }

  render() {
    if (this.state.successfullyVerified === null) {
      return (
        <div style={{width: '100%', marginTop:'50px'}}></div>
      );
    }
    else if (this.state.successfullyVerified) {
      return (
        <div className="Landing" id="contentId">
          <Header username={this.props.username} propagateLogin={this.props.propagateLogin} />
          <div className="ContentWithBackground">
            <div className="content" id="content">
              <div className=" marginTop30">
                <div className="landingContentText">
                  <h3>Ihr Profil wurde erfolgreich aktiviert.</h3>
                  <div className="marginTop10">
                    <div title="" className="button" onClick={(event) => this.props.history.push("/login")}>
                      <Link className="" to="/login" >Zum Login</Link></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Footer faqs={activationFaq} />
        </div>
      );
    }
    return (
      <div className="Landing" id="contentId">
        <Header username={this.props.username} propagateLogin={this.props.propagateLogin} />
        <div className="ContentWithBackground">
          <div className="content" id="content">
            <div className=" marginTop30">
              <div className="landingContentText">
                <p>Aktivierung fehlgeschlagen!</p>
              </div>
            </div>
          </div>
        </div>
        <Footer faqs={activationFaq} />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/verify-email.js